import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { cashbackConstants, cashbackModels } from '..';

export const useCashbackConfigSave = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: Partial<cashbackModels.ICashbackConfig>) => {
      const res = await $api.post('/v1/cashback/config', data);

      return res.data;
    },
    {
      onSuccess: res => {
        showMessage(res.message, res.accept);
        qc.invalidateQueries([cashbackConstants.queryKeys.CASHBACK_CONFIG_ALL]);
        qc.invalidateQueries([cashbackConstants.queryKeys.CASHBACK_ACTIVE]);
      }
    }
  );
};
